import { Grid, Typography, useTheme } from "@mui/material";
import { MprcJoinComponents } from "components";
import { MprcButton, MprcButtonProps } from "components/MprcButton";
import { AssessmentInstanceDto, AssessmentMode, AssessmentPlayerMode, AssessmentType } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    viewData?: AssessmentInstanceDto;
    loading: boolean;
    onStartClick: () => void;
}

export const AssPlayerStartActions: React.FC<IProps> = (props) => {

    const { viewData, loading, onStartClick } = props;
    const theme = useTheme();
    const { t } = useTranslation("assessment");

    ///
    const buildFooterInfo = (dto: AssessmentInstanceDto) => {
        let c: React.ReactNode[] = [];

        if (dto.assessmentType == AssessmentType.Evaluation || dto.playerMode != AssessmentPlayerMode.FinalResult) {
            c.push(
                <Typography variant="subtitle1" component="span" color={theme.palette.muted.main}>
                    <strong>{t("AssPlayer.StartBox.TotalQuestionText", { count: dto.totalQuestions })}</strong>
                </Typography>
            );
        }

        if (dto.mode == AssessmentMode.Evaluation && dto.eval?.timeToComplete && dto.eval.timeToComplete != null) {
            c.push(
                <Typography variant="subtitle1" component="span" color={theme.palette.warning.main}>
                    {t("AssPlayer.StartBox.TimeToCompleteText", { text: Formaters.secondsToFullTime(dto.eval.timeToComplete) })}
                </Typography>
            );
        }

        if (dto.mode == AssessmentMode.Survey && dto.playerMode != AssessmentPlayerMode.FinalResult && dto.playerMode != AssessmentPlayerMode.UserReview) {
            c.push(
                <Typography variant="subtitle1" component="span" color={theme.palette.muted.main}>
                    <strong>{t(dto.surv?.identifyUsers ? "AssPlayer.Survey.IdentifyUsersText" : "AssPlayer.Survey.AnonymousText")}</strong>
                </Typography>
            );
        }

        return <Typography variant="caption"><MprcJoinComponents components={c} separator={<span>&nbsp;&bull;&nbsp;</span>} /></Typography>;
    };

    ///
    const RenderStartButton = () => {
        var buttonProps: MprcButtonProps = {
            text: t("AssPlayer.StartBox.StartButtonText"),
            title: t("AssPlayer.StartBox.StartButtonTitle")
        };

        if (viewData?.mode == AssessmentMode.Evaluation && (viewData.playerMode == AssessmentPlayerMode.UserReview || viewData.playerMode == AssessmentPlayerMode.FinalResult)) {
            buttonProps = {
                text: t("AssPlayer.StartBox.ReviewButtonText"),
                title: t("AssPlayer.StartBox.ReviewButtonTitle")
            };
        }
        else if (viewData?.mode == AssessmentMode.Survey) {
            if (viewData.playerMode == AssessmentPlayerMode.UserReview) {
                buttonProps = {
                    text: t("AssPlayer.StartBox.ReviewAnswersButtonText"),
                    title: t("AssPlayer.StartBox.ReviewAnswersButtonTitle")
                };
            } else if (viewData.playerMode == AssessmentPlayerMode.FinalResult && viewData.surv?.expired == false) {
                buttonProps = {
                    text: t("AssPlayer.StartBox.SeeResultsButtonText"),
                    title: t("AssPlayer.StartBox.SeeResultsButtonTitle")
                };
            } else if (viewData.playerMode == AssessmentPlayerMode.FinalResult) {
                buttonProps = {
                    text: t("AssPlayer.StartBox.ViewEndResultButtonText"),
                    title: t("AssPlayer.StartBox.ViewEndResultButtonTitle")
                };
            } else if (viewData.playerMode == AssessmentPlayerMode.Update) {
                buttonProps = {
                    text: t("AssPlayer.StartBox.AnswerAgainButtonText"),
                    title: t("AssPlayer.StartBox.AnswerAgainButtonTitle")
                };
            } else {
                buttonProps = {
                    text: t("AssPlayer.StartBox.StartButtonText"),
                    title: t("AssPlayer.StartBox.StartButtonTitle")
                };
            }
        }

        return (
            <MprcButton
                {...buttonProps}
                variant="contained"
                color="info"
                onClick={onStartClick}
            />
        );
    };

    return (
        <>
            {
                !loading && viewData &&
                <Grid container spacing={1} alignItems="center" marginLeft={1} marginRight={1} width={"100%"}>
                    <Grid size="grow">
                        {buildFooterInfo(viewData)}
                    </Grid>
                    <Grid>
                        <Grid container spacing={1}>
                            <Grid>
                                {RenderStartButton()}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
        </>
    );
};
